module.exports = __webpack_public_path__ + "img/4.3f6a3ba3.jpg";